'use client'
import React, { Suspense } from 'react'
import SearchResults from '@/components/layout/search/serarchResults'

const AdvancedSearchResaultsPage = () => {
  return (
    <Suspense fallback={<></>}>
     <SearchResults/>
    </Suspense>
  )
}

export default AdvancedSearchResaultsPage
